// Pure helpers for the dashboard. Sale dates may be Date objects, strings or missing.
const toDate = (v) => {
  if (!v) return null;
  const x = v instanceof Date ? v : new Date(v);
  return Number.isNaN(x.getTime()) ? null : x;
};
const saleDate = (s) => toDate(s.date) || toDate(s.createdAt);
const amountOf = (s) => parseFloat(s.amount) || 0;

export const monthKey = (date) => {
  const x = toDate(date);
  return x ? `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, '0')}` : null;
};

export const listMonths = (sales, now = new Date()) => {
  const keys = new Set([monthKey(now)]);
  sales.forEach((s) => { const k = monthKey(saleDate(s)); if (k) keys.add(k); });
  return [...keys].sort().reverse();
};

export const salesInMonth = (sales, key) => sales.filter((s) => monthKey(saleDate(s)) === key);
export const salesInYear = (sales, year) =>
  sales.filter((s) => { const x = saleDate(s); return x && x.getFullYear() === Number(year); });

export const sumAmount = (sales) => sales.reduce((sum, s) => sum + amountOf(s), 0);

export const productName = (s) => s.product?.name || s.products?.name || s.productType || 'Unknown';

export const topProduct = (sales) => {
  const totals = {};
  sales.forEach((s) => { const n = productName(s); totals[n] = (totals[n] || 0) + amountOf(s); });
  const best = Object.entries(totals).sort((a, b) => b[1] - a[1])[0];
  return best ? { name: best[0], amount: best[1] } : { name: 'None', amount: 0 };
};

export const isSameDay = (a, b) => {
  const x = toDate(a); const y = toDate(b);
  return !!x && !!y && x.toDateString() === y.toDateString();
};

export const formatMonth = (key) => {
  const [y, m] = key.split('-').map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
};
